export interface ILayoutType {
  id: number;
  name: string;
}

export enum LayoutTypes {
  INDOOR = 'Indoor',
  OUTDOOR = 'Outdoor',
  MCCAFE = 'McCafe',
  DIGITAL_MERCHANDISER = 'Digital Merchandiser',
}

export enum LayoutTypeIds {
  INDOOR = 1,
  OUTDOOR = 2,
  MCCAFE = 3,
  DIGITAL_MERCHANDISER = 4,
}
